import { gsap } from 'gsap';

/**
 * Hamburger animatie 
 * 
 * 1. Animeer hamburger naar kruisje
 * 2. Zet de contentlaag voor het menu aan
 * 
*/

export function mobileNavigation() {
  let toggle = document.querySelector('.hamburger');
  let body = document.querySelector('body')
  // let navContainer = document.querySelector('.mobile-navigation-container')
  let bool = false;
  let myDiv = document.getElementById('menu-hoofdmenu');
  let list = myDiv.querySelectorAll(':scope > li');
  // let myDiv2 = document.getElementById('menu-top-menu');
  // let list2 = myDiv2.querySelectorAll(':scope > li');

  let tl = gsap.timeline({defaults: {ease: 'power2.inOut', duration: 0.5 }})
  
  toggle.addEventListener('click', function () {

    if (bool === false) {

      body.classList.add('stop-scroll');
      // navContainer.classList.add('animating');

      tl.timeScale( 1 ); 
      tl.restart();
      tl.to('.bar1', { duration:.1, width:'45px', height: '6px', top:'45%' , left:'15%', rotate: '45deg' })
      .to('.bar2', { duration:.1, opacity: 0 }, '<' )
      .to('.bar3', { duration:.1, width:'45px', height: '6px', top:'45%' , left:'15%', rotate: '-45deg'}, '<')
      .to('.mobile-navigation-container', { duration: .5, width: '100%', ease: 'power4.in' }, '<')
      .to( list, {duration: .2, opacity: 1, stagger: .05 })
      // .to( list2, {duration: .2, opacity: 1, stagger: .05 })

      bool = true;

    } else {
      body.classList.remove('stop-scroll');
      tl.timeScale( 1.5 ); 
      tl.reverse(1);
      bool = false;
    }
  })
}



    // accordion navigatie op mobiel
    // http://cssmenumaker.com/blog/wordpress-accordion-menu-tutorial/
    
    $('.nav-mobile li.has-sub-page>a').on('click', function(){
      // var href = $(this).attr('href'); 
      // $(this). attr('data-href', href);
      $(this).removeAttr('href');
      $(this).children('.link_text').prepend('<a>');

      var element = $(this).parent('li');
      if (element.hasClass('open')) {
        // var dataHref = $(this).attr('data-href'); 
        // $(this). attr('href', dataHref);
        element.removeClass('open');
        element.find('li').removeClass('open');
        element.find('ul').slideUp();
      }
      else {
        element.addClass('open');
        element.children('ul').slideDown();
        element.siblings('li').children('ul').slideUp();
        element.siblings('li').removeClass('open');
        element.siblings('li').find('li').removeClass('open');
        element.siblings('li').find('ul').slideUp();
      }
      //$(this). attr('href', href);
    });
  
    $('.nav-mobile li.has-sub-page>a').append('<span class="holder"></span>'); 
